// ===================================
// KAIXO - Traducciones UI centralizadas (reactivas)
// Proxy que lee el idioma del usuario en cada acceso.
// Orden de búsqueda: extraDict[lang] → translations[lang] → extraDict.en → translations.en
// No reemplaza translations.js; lo complementa para claves nuevas o faltantes.
// ===================================

import translations from './translations';

const langMap = {
    'español': 'es', 'inglés': 'en', 'francés': 'fr', 'alemán': 'de',
    'portugués': 'pt', 'italiano': 'it', 'euskera': 'eu', 'chino': 'zh',
    'japonés': 'ja', 'árabe': 'ar', 'hindi': 'hi', 'ruso': 'ru',
    'coreano': 'ko', 'turco': 'tr', 'indonesio': 'id',
    'english': 'en', 'spanish': 'es', 'french': 'fr', 'german': 'de',
    'portuguese': 'pt', 'italian': 'it', 'basque': 'eu', 'chinese': 'zh',
    'japanese': 'ja', 'arabic': 'ar', 'russian': 'ru', 'korean': 'ko',
    'turkish': 'tr', 'indonesian': 'id'
};

// Claves extra que NO están en translations.js (o que queremos reescribir).
// Cada sección debe existir al menos en 'es' y 'en'; si falta, cae a en.
const extraDict = {
    es: {
        common: {
            save: 'Guardar', cancel: 'Cancelar', close: 'Cerrar', delete: 'Eliminar',
            edit: 'Editar', send: 'Enviar', back: 'Atrás', confirm: 'Confirmar',
            search: 'Buscar', copy: 'Copiar', share: 'Compartir', yes: 'Sí', no: 'No',
            loading: 'Cargando...', error: 'Error', success: 'Éxito',
            add: 'Añadir', remove: 'Quitar', create: 'Crear', update: 'Actualizar',
            logout: 'Cerrar sesión', settings: 'Ajustes', profile: 'Perfil',
            darkMode: '🌙 Modo oscuro', lightMode: '☀️ Modo claro',
            you: 'Tú', user: 'Usuario', reactions: 'Reacciones', forwardedFile: 'Archivo reenviado',
            notifications: 'Notificaciones', channelNotifs: 'Anuncios de canales',
            appearance: 'Apariencia', plan: 'Plan', viewPlan: 'Ver plan y suscripción',
            openCRM: 'Abrir CRM', activateCRM: 'Activar CRM', crmRequiresPlan: 'CRM requiere plan Enterprise',
            impulso: 'Impulso', invite: 'Invitar amigos',
            personalMode: 'Modo personal', businessMode: 'Modo negocio'
        },
        menu: {
            createGroup: 'Crear grupo', channels: 'Canales', channelsLabel: 'Canales', heartbeats: 'Latidos',
            search: 'Buscar', logout: 'Cerrar sesión',
            darkMode: '🌙 Modo oscuro', lightMode: '☀️ Modo claro'
        },
        attach: {
            title: 'Adjuntar', gallery: 'Galería', camera: 'Cámara',
            video: 'Grabar video', audio: 'Audio', document: 'Documento',
            image: 'Imagen', voiceTranslation: 'Traducción de voz'
        },
        profile: {
            selectRegion: '-- Seleccionar región --',
            selectVoice: '-- Seleccionar voz --',
            testVoice: 'Probar'
        }
    },
    en: {
        common: {
            save: 'Save', cancel: 'Cancel', close: 'Close', delete: 'Delete',
            edit: 'Edit', send: 'Send', back: 'Back', confirm: 'Confirm',
            search: 'Search', copy: 'Copy', share: 'Share', yes: 'Yes', no: 'No',
            loading: 'Loading...', error: 'Error', success: 'Success',
            add: 'Add', remove: 'Remove', create: 'Create', update: 'Update',
            logout: 'Log out', settings: 'Settings', profile: 'Profile',
            darkMode: '🌙 Dark mode', lightMode: '☀️ Light mode',
            you: 'You', user: 'User', reactions: 'Reactions', forwardedFile: 'Forwarded file',
            notifications: 'Notifications', channelNotifs: 'Channel announcements',
            appearance: 'Appearance', plan: 'Plan', viewPlan: 'View plan & subscription',
            openCRM: 'Open CRM', activateCRM: 'Activate CRM', crmRequiresPlan: 'CRM requires Enterprise plan',
            impulso: 'Impulse', invite: 'Invite friends',
            personalMode: 'Personal mode', businessMode: 'Business mode'
        },
        menu: {
            createGroup: 'Create group', channels: 'Channels',
            search: 'Search', logout: 'Log out',
            darkMode: '🌙 Dark mode', lightMode: '☀️ Light mode'
        },
        attach: {
            title: 'Attach', gallery: 'Gallery', camera: 'Camera',
            video: 'Record video', audio: 'Audio', document: 'Document',
            image: 'Image', voiceTranslation: 'Voice translation'
        },
        profile: {
            selectRegion: '-- Select region --',
            selectVoice: '-- Select voice --',
            testVoice: 'Test'
        }
    },
    fr: {
        common: {
            save: 'Enregistrer', cancel: 'Annuler', close: 'Fermer', delete: 'Supprimer',
            edit: 'Modifier', send: 'Envoyer', back: 'Retour', confirm: 'Confirmer',
            search: 'Rechercher', copy: 'Copier', share: 'Partager', yes: 'Oui', no: 'Non',
            loading: 'Chargement...', error: 'Erreur', success: 'Succès',
            add: 'Ajouter', remove: 'Retirer', create: 'Créer', update: 'Mettre à jour',
            logout: 'Déconnexion', settings: 'Paramètres', profile: 'Profil',
            darkMode: '🌙 Mode sombre', lightMode: '☀️ Mode clair',
            you: 'Vous', user: 'Utilisateur', reactions: 'Réactions', forwardedFile: 'Fichier transféré',
            notifications: 'Notifications', appearance: 'Apparence',
            impulso: 'Impulse', invite: 'Inviter des amis',
            personalMode: 'Mode personnel', businessMode: 'Mode entreprise',
            heartbeats: 'Pulsations'
        },
        menu: {
            createGroup: 'Créer un groupe', channels: 'Canaux', heartbeats: 'Pulsations',
            search: 'Rechercher', logout: 'Déconnexion',
            darkMode: '🌙 Mode sombre', lightMode: '☀️ Mode clair'
        },
        attach: {
            title: 'Joindre', gallery: 'Galerie', camera: 'Caméra',
            video: 'Enregistrer vidéo', audio: 'Audio', document: 'Document',
            image: 'Image', voiceTranslation: 'Traduction vocale'
        },
        profile: {
            selectRegion: '-- Sélectionner région --',
            selectVoice: '-- Sélectionner voix --',
            testVoice: 'Tester'
        }
    },
    de: {
        common: {
            save: 'Speichern', cancel: 'Abbrechen', close: 'Schließen', delete: 'Löschen',
            edit: 'Bearbeiten', send: 'Senden', back: 'Zurück', confirm: 'Bestätigen',
            search: 'Suchen', copy: 'Kopieren', share: 'Teilen', yes: 'Ja', no: 'Nein',
            loading: 'Lädt...', error: 'Fehler', success: 'Erfolg',
            add: 'Hinzufügen', remove: 'Entfernen', create: 'Erstellen', update: 'Aktualisieren',
            logout: 'Abmelden', settings: 'Einstellungen', profile: 'Profil',
            darkMode: '🌙 Dunkelmodus', lightMode: '☀️ Hellmodus',
            you: 'Du', user: 'Benutzer', reactions: 'Reaktionen', forwardedFile: 'Weitergeleitete Datei',
            notifications: 'Benachrichtigungen', appearance: 'Erscheinungsbild',
            impulso: 'Impuls', invite: 'Freunde einladen',
            personalMode: 'Persönlicher Modus', businessMode: 'Geschäftsmodus',
            heartbeats: 'Herzschläge'
        },
        menu: {
            createGroup: 'Gruppe erstellen', channels: 'Kanäle', heartbeats: 'Herzschläge',
            search: 'Suchen', logout: 'Abmelden',
            darkMode: '🌙 Dunkelmodus', lightMode: '☀️ Hellmodus'
        },
        attach: {
            title: 'Anhängen', gallery: 'Galerie', camera: 'Kamera',
            video: 'Video aufnehmen', audio: 'Audio', document: 'Dokument',
            image: 'Bild', voiceTranslation: 'Sprachübersetzung'
        },
        profile: {
            selectRegion: '-- Region auswählen --',
            selectVoice: '-- Stimme auswählen --',
            testVoice: 'Testen'
        }
    },
    pt: {
        common: {
            save: 'Salvar', cancel: 'Cancelar', close: 'Fechar', delete: 'Excluir',
            edit: 'Editar', send: 'Enviar', back: 'Voltar', confirm: 'Confirmar',
            search: 'Pesquisar', copy: 'Copiar', share: 'Compartilhar', yes: 'Sim', no: 'Não',
            loading: 'Carregando...', error: 'Erro', success: 'Sucesso',
            add: 'Adicionar', remove: 'Remover', create: 'Criar', update: 'Atualizar',
            logout: 'Sair', settings: 'Ajustes', profile: 'Perfil',
            darkMode: '🌙 Modo escuro', lightMode: '☀️ Modo claro',
            you: 'Você', user: 'Usuário', reactions: 'Reações', forwardedFile: 'Arquivo encaminhado',
            notifications: 'Notificações', appearance: 'Aparência',
            impulso: 'Impulso', invite: 'Convidar amigos',
            personalMode: 'Modo pessoal', businessMode: 'Modo negócio',
            heartbeats: 'Pulsações'
        },
        menu: {
            createGroup: 'Criar grupo', channels: 'Canais', heartbeats: 'Pulsações',
            search: 'Pesquisar', logout: 'Sair',
            darkMode: '🌙 Modo escuro', lightMode: '☀️ Modo claro'
        },
        attach: {
            title: 'Anexar', gallery: 'Galeria', camera: 'Câmera',
            video: 'Gravar vídeo', audio: 'Áudio', document: 'Documento',
            image: 'Imagem', voiceTranslation: 'Tradução de voz'
        },
        profile: {
            selectRegion: '-- Selecionar região --',
            selectVoice: '-- Selecionar voz --',
            testVoice: 'Testar'
        }
    },
    it: {
        common: {
            save: 'Salva', cancel: 'Annulla', close: 'Chiudi', delete: 'Elimina',
            edit: 'Modifica', send: 'Invia', back: 'Indietro', confirm: 'Conferma',
            search: 'Cerca', copy: 'Copia', share: 'Condividi', yes: 'Sì', no: 'No',
            loading: 'Caricamento...', error: 'Errore', success: 'Successo',
            add: 'Aggiungi', remove: 'Rimuovi', create: 'Crea', update: 'Aggiorna',
            logout: 'Esci', settings: 'Impostazioni', profile: 'Profilo',
            darkMode: '🌙 Modalità scura', lightMode: '☀️ Modalità chiara',
            you: 'Tu', user: 'Utente', reactions: 'Reazioni', forwardedFile: 'File inoltrato',
            notifications: 'Notifiche', appearance: 'Aspetto',
            impulso: 'Impulso', invite: 'Invita amici',
            personalMode: 'Modo personale', businessMode: 'Modo business',
            heartbeats: 'Battiti'
        },
        menu: {
            createGroup: 'Crea gruppo', channels: 'Canali', heartbeats: 'Battiti',
            search: 'Cerca', logout: 'Esci',
            darkMode: '🌙 Modalità scura', lightMode: '☀️ Modalità chiara'
        },
        attach: {
            title: 'Allega', gallery: 'Galleria', camera: 'Fotocamera',
            video: 'Registra video', audio: 'Audio', document: 'Documento',
            image: 'Immagine', voiceTranslation: 'Traduzione vocale'
        },
        profile: {
            selectRegion: '-- Seleziona regione --',
            selectVoice: '-- Seleziona voce --',
            testVoice: 'Prova'
        }
    },
    eu: {
        common: {
            save: 'Gorde', cancel: 'Utzi', close: 'Itxi', delete: 'Ezabatu',
            edit: 'Editatu', send: 'Bidali', back: 'Atzera', confirm: 'Baieztatu',
            search: 'Bilatu', copy: 'Kopiatu', share: 'Partekatu', yes: 'Bai', no: 'Ez',
            loading: 'Kargatzen...', error: 'Errorea', success: 'Ondo',
            add: 'Gehitu', remove: 'Kendu', create: 'Sortu', update: 'Eguneratu',
            logout: 'Itxi saioa', settings: 'Ezarpenak', profile: 'Profila',
            darkMode: '🌙 Modu iluna', lightMode: '☀️ Modu argia',
            you: 'Zu', user: 'Erabiltzailea', reactions: 'Erreakzioak', forwardedFile: 'Birbidalitako fitxategia',
            notifications: 'Jakinarazpenak', channelNotifs: 'Kanaletako jakinarazpenak',
            appearance: 'Itxura', plan: 'Plana', viewPlan: 'Ikusi plana eta harpidetza',
            openCRM: 'Ireki CRM', activateCRM: 'Aktibatu CRM', crmRequiresPlan: 'CRM-k Enterprise plana behar du',
            impulso: 'Bultzada', invite: 'Lagunei gonbidatu',
            personalMode: 'Modu pertsonala', businessMode: 'Negozio modua',
            heartbeats: 'Taupadak'
        },
        menu: {
            createGroup: 'Sortu taldea', channels: 'Kanalak', heartbeats: 'Taupadak',
            search: 'Bilatu', logout: 'Itxi saioa',
            darkMode: '🌙 Modu iluna', lightMode: '☀️ Modu argia'
        },
        attach: {
            title: 'Erantsi', gallery: 'Galeria', camera: 'Kamera',
            video: 'Grabatu bideoa', audio: 'Audioa', document: 'Dokumentua',
            image: 'Irudia', voiceTranslation: 'Ahots-itzulpena'
        },
        profile: {
            selectRegion: '-- Aukeratu eskualdea --',
            selectVoice: '-- Aukeratu ahotsa --',
            testVoice: 'Probatu'
        }
    }
};

function currentLang() {
    try {
        const user = JSON.parse(localStorage.getItem('kaixo_user'));
        const code = langMap[user?.language?.toLowerCase()];
        if (code) return code;
    } catch {}
    const nav = (navigator.language || 'en').split('-')[0].toLowerCase();
    return langMap[nav] || (extraDict[nav] ? nav : 'en');
}

// Resuelve una sección (ej: 'profile') en el idioma actual con fallbacks.
function resolveSection(section) {
    const lang = currentLang();
    const fromExtra = extraDict[lang]?.[section];
    const fromTranslations = translations[lang]?.[section];
    const fromExtraEn = extraDict.en?.[section];
    const fromTranslationsEn = translations.en?.[section];
    // Merge: base EN → ES translation → extraDict EN → extraDict current
    return {
        ...(fromTranslationsEn || {}),
        ...(fromExtraEn || {}),
        ...(fromTranslations || {}),
        ...(fromExtra || {})
    };
}

// Proxy de sección: devuelve string directo o section resuelto on-demand
function makeSectionProxy(section) {
    return new Proxy({}, {
        get(_t, key) {
            const resolved = resolveSection(section);
            return resolved[key];
        },
        ownKeys() { return Object.keys(resolveSection(section)); },
        getOwnPropertyDescriptor() { return { enumerable: true, configurable: true }; }
    });
}

// Proxy raíz: ui.profile, ui.chat, etc.
const ui = new Proxy({}, {
    get(_t, section) {
        return makeSectionProxy(section);
    }
});

export default ui;
export function getCurrentLangCode() { return currentLang(); }
